module.exports = __webpack_public_path__ + "static/img/doc-btn-bg.4f7c8f16.png";